<template>
  <div class="serveSupplier">
    <v-header />
    <div class="serveSupplier-con">
      <div class="serveSupplierCon-top">
        <img v-if="$i18n.locale === 'zh-CN'" src="./image/top.png" />
        <img v-if="$i18n.locale === 'en-US'" src="./image/top-US.png" />
        <div class="button">
          <img v-if="$i18n.locale === 'zh-CN'" src="./image/getServe.png" />
          <img v-if="$i18n.locale === 'en-US'" src="./image/getServe-US.png" />
        </div>
      </div>
      <div class="serveSupplierCon-2">
        <div class="bai"></div>
        <div class="hui"></div>
        <div class="nei">
          <div class="nei-left">
            <div v-if="$i18n.locale === 'zh-CN'" class="nei-title">
              <p>供应商评估</p>
              <p>还原供应商真实面貌</p>
            </div>
            <div v-if="$i18n.locale === 'en-US'" class="nei-title">
              <p>Real data reveals the true nature</p>
            </div>
            <div v-if="$i18n.locale === 'zh-CN'" class="nei-title1">
              清晰识别供应商
            </div>
            <div v-if="$i18n.locale === 'zh-CN'" class="nei-con">
              <p>多维度，深层次挖掘供应商能力</p>
              <p>洽谈合作，运筹帷幄 细致展现真实可靠的数据，</p>
              <p>为您的决策带来实实在在的支持</p>
            </div>
            <div v-if="$i18n.locale === 'en-US'" class="nei-con">
              <p>
                You are able to access to your potential vendor in a much more
                efficient way. We present detailed data and files of the vendor
                which will be quite crucial to your decision.
              </p>
            </div>
          </div>
          <div class="nei-right">
            <img src="./image/2311.png" />
          </div>
        </div>
      </div>
      <div class="serveSuoolierCon-3">
        <div class="item1 item">
          <div class="nei">
            <div class="nei-right">
              <img src="./image/33.png" />
            </div>
            <div class="nei-left">
              <div><img src="./image/1533-2.png" /></div>
              <div class="pos">
                <div v-if="$i18n.locale === 'zh-CN'" class="nei-title1">
                  精耕细分市场
                </div>
                <div v-if="$i18n.locale === 'en-US'" class="nei-title1">
                  Get a close look of your vendor
                </div>
                <div class="nei-con">
                  <p v-if="$i18n.locale === 'zh-CN'">
                    行业不同，从业人员所需配备的行业背要，专业知识各异。曼德精确识别细分行业，评估分析更准确
                  </p>
                  <p v-if="$i18n.locale === 'en-US'">
                    Industries varies from each other. Expertise is required in
                    dealing with certain business. We analyze and assess your
                    vendor in a particular way.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="item2 item">
          <div class="nei">
            <div class="nei-left">
              <div><img src="./image/2319.png" /></div>
              <div class="pos">
                <div v-if="$i18n.locale === 'zh-CN'" class="nei-title1">
                  高效快捷，精准决策
                </div>
                <div v-if="$i18n.locale === 'en-US'" class="nei-title1">
                  High efficient system, Faster than ever
                </div>
                <div class="nei-con">
                  <p v-if="$i18n.locale === 'zh-CN'">
                    基于曼德流程化的服务系统，我们以最快速度将您呈现供应商资质报告让您能够在短时间内掌握多个供应商情况，您的决策将无比准确，快速
                  </p>
                  <p v-if="$i18n.locale === 'en-US'">
                    We are capable to assess multiple vendors simultaneously
                    which allows you to review potential vendors at the same
                    time .
                  </p>
                </div>
              </div>
            </div>
            <div class="nei-right">
              <img src="./image/231844.png" />
            </div>
          </div>
        </div>
        <div class="item1 item">
          <div class="nei">
            <div class="nei-right">
              <img src="./image/2318.png" />
            </div>
            <div class="nei-left">
              <div class="pos">
                <div v-if="$i18n.locale === 'zh-CN'" class="nei-title1">
                  高弹性反馈机制
                </div>
                <div v-if="$i18n.locale === 'en-US'" class="nei-title1">
                  We know what you care most
                </div>
                <div class="nei-con">
                  <p v-if="$i18n.locale === 'zh-CN'">
                    曼德建立弹性互动机制，特殊需求可定制，一次搞定你对供应商的所有疑惑
                  </p>
                  <p v-if="$i18n.locale === 'en-US'">
                    With our flexible order system, your special requirements
                    will be well noticed. You are able to grab the details that
                    you care most.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="$i18n.locale === 'zh-CN'" class="serveSuoolierCon-4">
        <p class="p1">惊喜的不只有服务</p>
        <p class="p2">我们为您创造更多价值</p>
        <div class="pice-box">
          <p>供应商评估服务</p>
          <p>低至<span>720</span>元起</p>
        </div>
        <div class="pice-button">
          <img src="./image/getPice.png" />
        </div>
      </div>
      <div v-if="$i18n.locale === 'en-US'" class="serveSuoolierCon-4">
        <p class="p1">Best Service With Amazing Price</p>
        <p class="p2">we create more</p>
        <div class="pice-box">
          <p>Factory Assessment Service</p>
          <p>start from $<span>125</span></p>
        </div>
        <div class="pice-button">
          <img src="./image/getPice-US.png" />
        </div>
      </div>
    </div>
    <v-footer />
  </div>
</template>
<script>
import Header from '../home/components/header.vue';
import Footer from '../home/components/footer.vue';
export default {
  components: {
    'v-header': Header,
    'v-footer': Footer,
  },
};
</script>
<style lang="less">
.serveSupplier {
  .serveSupplier-con {
    .serveSupplierCon-top {
      position: relative;
      > img {
        width: 100%;
      }
      .button {
        position: absolute;
        bottom: 25%;
        left: calc(50% - 70px);
        cursor: pointer;
      }
    }
    .serveSupplierCon-2 {
      position: relative;
      .bai {
        height: 240px;
      }
      .hui {
        height: 500px;
        background-color: #eeeeee;
      }
      .nei {
        position: absolute;
        top: 100px;
        justify-content: space-between;
        .nei-title {
          margin: 85px 0 70px;
        }
      }
    }
    .serveSuoolierCon-3 {
      .item {
        padding: 160px 0 50px;
        .nei {
          > div {
            width: 45%;
          }
        }
      }
      .item1 {
        .nei {
          .nei-right {
            text-align: right;
            margin-right: 10%;
          }
          .nei-left {
            position: relative;
            .pos {
              position: absolute;
              top: 267px;
              left: 70px;
            }
          }
        }
      }
      .item2 {
        .nei-right {
          text-align: left;
          margin-left: 10%;
        }
        .nei-left {
          position: relative;
          padding-left: 10%;
          .pos {
            position: absolute;
            top: 267px;
            left: calc(10% + 100px);
          }
        }
      }
    }
    .nei {
      top: 100px;
      display: flex;
      margin: 0 10%;
      width: 80%;
      .nei-left {
        text-align: left;
        p {
          margin-bottom: 0;
        }
        .nei-title {
          font-size: 46px;
          color: #02b8fb;
        }
        .nei-title1 {
          font-size: 28px;
          color: #242424;
          margin-bottom: 30px;
        }
        .nei-con {
          font-size: 24px;
          color: #727272;
        }
      }
    }
    .serveSuoolierCon-4 {
      margin: 60px 0 200px;
      p {
        margin-bottom: 26px;
      }
      .p1 {
        font-size: 36px;
      }
      .p2 {
        font-size: 20px;
      }
      .pice-box {
        width: 570px;
        height: 350px;
        border-top: 12px solid #1696ff;
        margin: 50px auto 100px;
        box-shadow: 0 0 5px 0 #999;
        padding-top: 30px;
        p {
          font-size: 20px;
          span {
            font-size: 90px;
            color: #6db3ff;
          }
        }
      }
      .pice-button {
        cursor: pointer;
      }
    }
  }
}
</style>
